import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtTag } from "server/models"
import { StateType, deepCopy } from "client/utils"
import {
    StoreType,
    TagList,
    TagFilters,
    LoadAllTags,
    DeleteTag,
    SortTags,
    setTagList,
    setTagIds,
    setTagSort,
    setTagFilters,
    setTagEdit,
    initTag,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import TagSearch from "client/pages/search/tagSearch"
import Columns from "./columns"
import Edit from "./edit"

const List = () => {
    const tagList = useSelector((state: StoreType) => state.tag.tagList)
    const tagIds = useSelector((state: StoreType) => state.tag.tagIds)
    const sortColumn = useSelector((state: StoreType) => state.tag.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.tag.sortOrder)
    const filters = useSelector((state: StoreType) => state.tag.filters)
    const reloadList = useSelector((state: StoreType) => state.tag.reloadList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllTags().then((res) => {
            dispatch(setTagList(res.tagList))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortTags(Object.values(tagList), sortColumn, sortOrder, filters)
        dispatch(setTagIds(sortedIds))
    }, [tagList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtTag, order) => {
        dispatch(setTagSort(column, order))
    }

    const onFilter = (newFilters: TagFilters) => {
        dispatch(setTagFilters(newFilters))
    }

    const onDelete: DeleteRow = (tag: MtTag, callback) => {
        DeleteTag(tag.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const tagListCopy: TagList = tagList ? deepCopy(tagList) : {}
                delete tagListCopy[tag.id]
                dispatch(setTagList(tagListCopy))
                dispatch(setTagIds(tagIds.filter((id) => id !== tag.id)))
            })
        })
    }

    const columns = Columns()

    if (userData.accountId !== 1) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.tags}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <TagSearch
                        id="tagList"
                        rightOffset
                        filters={filters}
                        onFilter={onFilter}
                    />
                    <Button
                        variant="success"
                        onClick={() => dispatch(setTagEdit(initTag))}
                    >
                        {lang.add}
                    </Button>
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={tagList}
                    dataIds={tagIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    onSort={onSort}
                    onDelete={onDelete}
                />
            </PageContent>

            <Edit />
        </Container>
    )
}
export default List
